package dk.smark.demo.location

sealed interface LocationResult {
    data class Success(val location: GenericLocation) : LocationResult
    data class Error(val reason: LocationError) : LocationResult
}

sealed interface LocationError {
    data object PermissionDenied : LocationError
    data object LocationUnavailable : LocationError
    data object Timeout : LocationError
    data class Unknown(val message: String? = null) : LocationError
}